import React from 'react';
import { Skeleton } from 'antd';
import { getCurrency } from '../Common/utils';
import { PriceTag } from '../Common/Tags';
import { ChargeTotals } from './useChargeStatistics';

/**
 * What the filtered set of charges comes to. It stands beside the chart rather
 * than under it — the chart says how the spend moved, these say what it adds
 * up to, and the two answer the same question from opposite ends.
 *
 * Stacked rather than in a row, so it fills the column the chart leaves.
 */
const ChargeSummary = ({ totals, loading }: { totals: ChargeTotals | null; loading?: boolean }) => {
    const currency = getCurrency();

    const figures = [
        {
            label: 'Total charged',
            value: <PriceTag amount={totals?.sum_total_charge || 0} currency={currency} />,
            lead: true,
        },
        {
            label: 'Processed',
            value: <PriceTag amount={totals?.sum_total_processed || 0} currency={currency} />,
        },
        {
            label: 'Charges',
            value: totals?.num_of_charges ?? 0,
        },
    ];

    return (
        <div className="chg-summary">
            <h3 className="chg-summary__title">Summary</h3>

            {loading ? (
                <Skeleton active paragraph={{ rows: 3 }} title={false} />
            ) : (
                <dl className="chg-summary__list">
                    {figures.map((figure) => (
                        <div
                            key={figure.label}
                            className={`chg-figure${figure.lead ? ' chg-figure--lead' : ''}`}
                        >
                            <dt className="chg-figure__label">{figure.label}</dt>
                            <dd className="chg-figure__value">{figure.value}</dd>
                        </div>
                    ))}
                </dl>
            )}
        </div>
    );
};

export default ChargeSummary;
